module.exports = "::ng-deep .ui-multiselect-label {\n  padding: 0 !important;\n  font-weight: initial; }\n\n::ng-deep .ui-multiselect-trigger-icon:before {\n  content: \"\\f078\" !important;\n  font-size: 11px; }\n\n::ng-deep .ui-multiselect-trigger .fa {\n  margin-top: .5em !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cfc/cadastro-cfc-form/cadastro-cfc-form.component.scss
// module id = ./src/app/components/cfc/cadastro-cfc-form/cadastro-cfc-form.component.scss
// module chunks = main